import { post } from '../../utils/Backend';
import { useLongfansMock } from '../../global/GlobalMock';
import type {
  InstHotspotAccessQuery,
  InstHotspotSearchItem,
  InstHotspotStockDetail,
  InstHotspotThemeBrief,
  InstHotspotThemeDetail,
} from './InstHotspotType';
import {
  mockGetQuickNewsStocks,
  mockGetThemeDetail,
  mockListThemes,
  mockSearchQuickNews,
} from './InstHotspotMock';

const mock = useLongfansMock && false;

const URL_LIST = '/lark/app/quick-news/listThemes';
const URL_SEARCH = '/lark/app/quick-news/searchQuickNews';
const URL_THEME_DETAIL = '/lark/app/quick-news/getThemeDetail';
const URL_STOCKS = '/lark/app/quick-news/getQuickNewsStocks';

function unwrap<T>(res: T | string): T {
  if (typeof res === 'string') throw new Error(res);
  return res;
}

export const InstHotspotApi = {
  async listThemes(
    query: InstHotspotAccessQuery
  ): Promise<{ themes: InstHotspotThemeBrief[]; hotKeywords: string[] }> {
    if (mock) {
      const themes = await mockListThemes(query.rankMode);
      return { themes, hotKeywords: ['低空经济', '半导体'] };
    }
    const res = await post<
      InstHotspotAccessQuery,
      { themes: InstHotspotThemeBrief[]; hotKeywords?: string[] }
    >(URL_LIST, query, { silent: true });
    const data = unwrap(res);
    return { themes: data.themes ?? [], hotKeywords: data.hotKeywords ?? [] };
  },

  async searchQuickNews(
    query: InstHotspotAccessQuery & { keyword: string }
  ): Promise<{ items: InstHotspotSearchItem[] }> {
    if (mock) {
      const items = await mockSearchQuickNews(query.keyword);
      return { items };
    }
    const res = await post<typeof query, { items: InstHotspotSearchItem[] }>(URL_SEARCH, query, {
      silent: true,
    });
    return unwrap(res);
  },

  async getThemeDetail(
    query: InstHotspotAccessQuery & { themeId: string }
  ): Promise<InstHotspotThemeDetail> {
    if (mock) {
      return mockGetThemeDetail(query.themeId);
    }
    const res = await post<typeof query, InstHotspotThemeDetail>(URL_THEME_DETAIL, query, {
      silent: true,
    });
    return unwrap(res);
  },

  async getQuickNewsStocks(
    query: InstHotspotAccessQuery & { quickNewsId: string }
  ): Promise<InstHotspotStockDetail> {
    if (mock) {
      return mockGetQuickNewsStocks(query.quickNewsId);
    }
    const res = await post<typeof query, InstHotspotStockDetail>(URL_STOCKS, query, {
      silent: true,
    });
    return unwrap(res);
  },
};
